
$(document).click(function() {
    $(".product-popup").removeClass("active");
    $("body").removeClass("product-popup-open");
});
$( ".popup-inner" ).click(function(e) {
  e.stopPropagation();
});
$( ".overlay-product-btn" ).click(function(e) {
  e.stopPropagation();
  $(".product-popup").addClass("active");
  $("body").addClass("product-popup-open");
});
$( ".close-popup" ).click(function(e) {
  e.stopPropagation();
  $(".product-popup").removeClass("active");
  $("body").removeClass("product-popup-open");
});
$( ".product-images div img" ).click(function(e) {
 $( ".product-images div" ).removeClass("active");
  $(this).closest(".pd-variant").addClass("active");
  if(jQuery(this).attr('video'))
  {
    console.log(jQuery(this).attr('video'));
    $(".video-container iframe").attr("src",jQuery(this).attr('video'));
    $(".video-container").show();
    $(".image-wrapper").hide();
  }
  else{
    var newsrc = $(this).attr('src');
    $(".video-container").hide();
     console.log(newsrc);
     $(".product-main-image img").attr("src",newsrc);
     $(".product-popup figure.zoom").css("background-image", "url(https://"+newsrc+")");
    $(".image-wrapper").show();
  }
 
});
function toggleZoom(event) {
  const figure = event.currentTarget;
  const img = figure.querySelector('img');
  
  if (!figure.classList.contains('zoomed')) {
      const rect = figure.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      img.style.transformOrigin = `${x}px ${y}px`;
      img.style.transform = 'scale(3)'; // Adjust scale as needed
      figure.classList.add('zoomed');
  } else {
      img.style.transform = 'scale(1)';
      figure.classList.remove('zoomed');
  }
}
